import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Grid,
  Card,
  CardContent,
  Button,
  CircularProgress,
  TablePagination,
} from "@mui/material";
import { useLotAnalysis } from "../hooks/useLotAnalysis";
import { LotAnalysisModal } from "../components/LotAnalysisModal";
import { LotDetailsModal } from "./LotDetailsModal";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const SearchResultsTable = ({
  data,
  hiddenData,
  easyData,
  similarData,
  isLoading,
  isHiddenLoading,
  isEasyLoading,
  isSimilarLoading,
  page,
  setPage,
  pageLimit,
  setPageLimit,
  total,
  hiddenTotal,
  easyTotal,
  similarTotal,
  fetchEasyLots,
  fetchSimilarLots,
}) => {
  const [tab, setTab] = useState(0);
  const handleTabChange = (_, newValue) => setTab(newValue);
  const handleChangePage = (_, newPage) => setPage(newPage + 1);
  const handleChangeRowsPerPage = (e) => {
    setPageLimit(parseInt(e.target.value, 10));
    setPage(1);
  };
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    console.log("data after: ", data);
  });

  const {
    isOpen,
    loading,
    fileData,
    summary,
    error,
    isInProgress,
    analyzeLot,
    retryAnalysis,
    closeModal,
  } = useLotAnalysis();
  const [selectedLot, setSelectedLot] = useState(null);
  const handleAnalyze = (lot) => {
    setSelectedLot(lot);
    analyzeLot(lot);
    console.log("LOT CLICKED:", lot);
  };

  const [openDetails, setOpenDetails] = useState(false);
  const [selectedLotDetails, setSelectedLotDetails] = useState(null);

  const handleOpenDetails = (lot) => {
    setSelectedLotDetails(lot);
    setOpenDetails(true);
  };

  const handleCloseDetails = () => {
    setOpenDetails(false);
    setSelectedLotDetails(null);
  };

  let activeData, activeLoading, activeTotal;

  /* 0 — обычный поиск */
  if (tab === 0) {
    activeData = data;
    activeLoading = isLoading;
    activeTotal = total;
  } else if (tab === 1) {
    /* 1 — расширенный */
    activeData = hiddenData;
    activeLoading = isHiddenLoading;
    activeTotal = hiddenTotal;
  } else if (tab === 2) {
    /* 2 — легкие лоты */
    activeData = easyData;
    activeLoading = isEasyLoading;
    activeTotal = easyTotal;
  } else if (tab === 3) {
    /* 3 — похожие лоты */
    activeData = similarData;
    activeLoading = isSimilarLoading;
    activeTotal = similarTotal;
  }

  //  // Источник данных для сводки
  let summarySource = null;

  if (tab === 0) summarySource = data;
  else if (tab === 1) summarySource = hiddenData;
  else if (tab === 2) summarySource = easyData;
  else if (tab === 3) summarySource = similarData;

  let amountFormatted =
    summarySource?.amountOfLotsByDefaultSearchFormatted ??
    summarySource?.amountOfHiddenLotsFormatted ??
    summarySource?.amountOfEasyLotsFormatted ??
    "Нет данных";

  let countFormatted =
    summarySource?.countOfLotsByDefaultSearchFormatted ??
    summarySource?.countOfHiddenLotsFormatted ??
    summarySource?.countOfEasyLotsFormatted ??
    "Нет данных";

  // console.log("TAB:", tab);
  // console.log("activeData:", activeData);
  // console.log("hiddenData:", hiddenData);

  const rows = activeData?.data ?? activeData ?? [];

  return (
    <Box mt={3}>
      <Box mb={2}>
        <Typography variant="h6">
          Общая сумма лотов: <strong>{amountFormatted}</strong>
        </Typography>

        <Typography variant="h6">
          Общее количество лотов: <strong>{countFormatted}</strong>
        </Typography>
      </Box>
      {/* Вкладки */}
      <Tabs value={tab} onChange={handleTabChange} sx={{ mb: 2 }}>
        <Tab label="Результаты обычного поиска" />
        <Tab label="Результаты расширенного поиска" />
        <Tab label="Легкие лот ты"></Tab>
        <Tab label="Похожие лоты"></Tab>
      </Tabs>
      {data.stats && (
        <div className="mb-5">
          <div className="flex flex-wrap justify-between gap-y-4">
            {/* 🔹 первые 2 */}
            {data.stats.slice(0, 2).map((s, index) => (
              <div
                key={index}
                className="text-xl w-[49%] shadow-[0_0_3px_rgba(1,1,1,0.5)] border rounded-xl p-5"
              >
                {" "}
                <div className="mb-5 font-bold text-2xl">{s.text}</div>
                <div className="text-sm flex justify-between mb-2">
                  <div>Обычный поиск</div>
                  <div className="text-right">
                    <div>{s.countOfLotsByDefaultSearchFormatted}</div>
                    <div>{s.amountOfLotsByDefaultSearchFormatted}</div>
                  </div>
                </div>
                <div className="text-sm flex justify-between">
                  <div>Расширенный поиск</div>
                  <div className="text-right">
                    <div>{s.countOfHiddenLotsFormatted}</div>
                    <div>{s.amountOfHiddenLotsFormatted}</div>
                  </div>
                </div>
              </div>
            ))}

            {/* 🔹 остальные (появляются в том же блоке) */}
            {expanded &&
              data.stats.slice(2).map((s, index) => (
                <div
                  key={index + 2}
                  className="text-xl w-[49%] shadow-[0_0_3px_rgba(1,1,1,0.5)] border rounded-xl p-5 transition-all duration-300"
                >
                  <div className="mb-5 font-bold text-2xl">{s.text}</div>
                  <div className="text-sm flex justify-between mb-2">
                    <div>Обычный поиск</div>
                    <div className="text-right">
                      <div>{s.countOfLotsByDefaultSearchFormatted}</div>
                      <div>{s.amountOfLotsByDefaultSearchFormatted}</div>
                    </div>
                  </div>
                  <div className="text-sm flex justify-between">
                    <div>Расширенный поиск</div>
                    <div className="text-right">
                      <div>{s.countOfHiddenLotsFormatted}</div>
                      <div>{s.amountOfHiddenLotsFormatted}</div>
                    </div>
                  </div>
                </div>
              ))}
          </div>

          {/* 🔹 кнопка внутри того же блока */}
          {data.stats.length > 2 && (
            <div className="flex justify-center mt-4">
              <button
                onClick={() => setExpanded(!expanded)}
                className="px-4 py-2 border rounded-lg shadow hover:bg-gray-100 transition"
              >
                {expanded ? "Скрыть" : "Показать ещё"}
              </button>
            </div>
          )}
        </div>
      )}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          pr: 1,
          maxHeight: "65vh", // 🔴 регулируй под дизайн
          boxShadow: "inset 0 4px 6px -6px rgba(0,0,0,0.1)",
        }}
      >
        {activeLoading ? (
          <Box textAlign="center" mt={4}>
            <CircularProgress />
          </Box>
        ) : (
          // ===== Вкладка карточек =====
          <Grid container spacing={2}>
            {rows.map((lot) => (
              <Grid item xs={12} key={lot.id}>
                <Card
                  variant="outlined"
                  onClick={() => handleOpenDetails(lot)}
                  sx={{
                    borderRadius: 2,
                    borderColor: lot.isHot ? "purple" : "grey.400",
                    p: 2,
                    position: "relative",
                  }}
                >
                  <CardContent>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="flex-start"
                    >
                      <Box>
                        {/* <Typography variant="subtitle2" color="text.secondary">
                      {lot.number} — {lot.trade}
                    </Typography> */}
                        <Typography variant="h6" sx={{ mt: 1 }}>
                          {lot.name}
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 0.5 }}>
                          {lot.description}
                        </Typography>
                        {/* <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                      {lot.customer}
                    </Typography> */}
                        {/* <Typography variant="body2" color="text.secondary">
                      {lot.locality}
                    </Typography> */}
                      </Box>

                      <Box textAlign="center" flex="0 0 200px">
                        <Typography variant="h6">Количество</Typography>
                        <Typography variant="body2">
                          {lot.unitPrice != null
                            ? lot.unitPrice.toLocaleString()
                            : "—"}{" "}
                          × {lot.count ?? "—"}
                        </Typography>

                        <Typography variant="body1" sx={{ mt: 1 }}>
                          {lot.amount != null
                            ? `${lot.amount.toLocaleString()} ₸`
                            : "—"}
                        </Typography>
                      </Box>

                      <Box textAlign="right" flex="0 0 220px">
                        <Typography variant="caption" color="text.secondary">
                          Таймер: {Math.floor(lot.secondsLeft / 3600)} ч
                        </Typography>

                        <Box mt={1}>
                          {lot.isHot && (
                            <Typography color="error">
                              🔥 Горячий лот
                            </Typography>
                          )}
                          {lot.isUnion && (
                            <Typography>🔗 Объединённый</Typography>
                          )}
                          {lot.isDisabledPerson && (
                            <Typography>♿ Инвалидная организация</Typography>
                          )}
                          {lot.nationalRegime === 2 && (
                            <Typography color="primary">
                              🇰🇿 Нац. режим
                            </Typography>
                          )}
                          {lot.analyzedByUser && (
                            <Typography color="success.main">
                              🧠 Анализ уже выполнен
                            </Typography>
                          )}
                        </Box>

                        <Button
                          variant="outlined"
                          color="success"
                          sx={{ mt: 2, borderWidth: 2 }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleAnalyze(lot);
                          }}
                        >
                          Анализ
                        </Button>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
            <Box display="flex" justifyContent="center" mt={2}>
              <TablePagination
                component="div"
                count={activeTotal ?? 0}
                page={page - 1}
                onPageChange={handleChangePage}
                rowsPerPage={pageLimit}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[3, 10, 25, 50]}
                labelRowsPerPage="На странице:"
                labelDisplayedRows={({ from, to, count }) =>
                  `${from}–${to} из ${count !== -1 ? count : `более ${to}`}`
                }
              />
            </Box>
          </Grid>
        )}
      </Box>
      <LotAnalysisModal
        open={isOpen}
        onClose={closeModal}
        loading={loading}
        fileData={fileData}
        summary={summary}
        error={error}
        isInProgress={isInProgress}
        retryAnalysis={retryAnalysis}
        currentLot={selectedLot}
      />
      <LotDetailsModal
        open={openDetails}
        onClose={handleCloseDetails}
        lot={selectedLotDetails}
      />
    </Box>
  );
};

export default SearchResultsTable;
